import React from 'react';

import { useMyUserIsInternalAdmin } from 'store/modules/myUser/hooks';

/**
 * Includes a leading whitespace to allow seamless concatenation with other elements
 */
export default function InternalAdminNote({ message }: { message: InternalAdminMessage }) {
  const isInternalAdmin = useMyUserIsInternalAdmin();
  if (!isInternalAdmin) return null;
  return (
    <>{' '}<span className="internal-admin">{message}</span></>
  );
}

export enum InternalAdminMessage {
  CIBO_LOCATION_MOVABILITY = 'Note: The 48 hour limit doesn’t apply to Internal Admins.',
  SUBSCRIBE_TO_ALERTS = 'Note: Only enterprise members can subscribe to alerts.',
  SUBSCRIBE_TO_REPORTS = 'Note: Only enterprise members can subscribe to reports.'
}